import { render } from "./ResellerShow.vue?vue&type=template&id=320c2ff0"
import script from "./ResellerShow.vue?vue&type=script&lang=js"
export * from "./ResellerShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__